import Vue from 'vue'
import uniqid from 'uniqid'

const Customers = {
  state: {
    countries: {},
    customers: {
      /*
        customer_id: {
            id: '',
            firstname: '',
            lastname: '',
            cart: [
              'delivery_address': '',
              'options': '',
              'products': [
                {
                  cart_quantity: 1,
                  created: true,
                  id: 'autogenerated',
                  measure_id: '456',
                  name: 'Shirt',
                  options: {
                    294: {
                      682: {
                        ...
                      }
                    }
                  },
                  price: 99,
                  source: 'customized'
                }
              ],
            ],
        }
        */
    },
    current_customer_id: null,
    current_shirt_id: null,
    current_measure_id: null,
    current_address_id: null
  },
  getters: {
    getCustomers: (state) => state.customers,
    getCurrentCustomer: (state) => {
      if (!state.current_customer_id) {
        return null
      }
      return state.customers[state.current_customer_id]
    },
    getCart: (state) => {
      const customer = state.customers[state.current_customer_id]

      if (!customer) {
        return {}
      }
      return customer.cart
    },
    getCartProducts: (state) => {
      const customer = state.customers[state.current_customer_id]

      if (!customer) {
        return {}
      }

      if(!customer.cart) {
        return {}
      }

      if(!customer.cart.products) {
        return {}
      }

      return customer.cart.products
    },
    getCartAmount: (state) => {
      const customer = state.customers[state.current_customer_id]

      if (!customer) {
        return 0
      }

      let total = 0
      customer.cart.products.forEach((product) => {
        total += product.price;
      })
      return total
    },
    getCurrentShirt: (state) => {
      if (!state.customers[state.current_customer_id]) {
        return null
      }

      let current = null
      state.customers[state.current_customer_id].cart.products.some((shirt) => {
        if (shirt.id === state.current_shirt_id) {
          current = shirt
          return true
        }
        return false
      })
      return current
    },
    getCurrentMeasure: (state) => {
      if (!state.customers[state.current_customer_id]) {
        return null
      }

      let current = null
      state.customers[state.current_customer_id].measures.some((measure) => {
        if (measure.id === state.current_measure_id) {
          current = measure
          return true
        }
        return false
      })
      return current
    },
    getCurrentAddress: (state) => {
      if (!state.customers[state.current_customer_id]) {
        return null
      }

      let current = null
      state.customers[state.current_customer_id].addresses.some((address) => {
        if (address.id === state.current_address_id) {
          current = address
          return true
        }
        return false
      })
      return current
    }
  },
  actions: {
    addCustomer({ commit }, customer) {
      commit('ADD_CUSTOMER', customer)
    },
    setCurrentCustomer({ commit }, customer) {
      commit('SET_CURRENT_CUSTOMER', customer)
    },
    addToCart({commit}, product) {
      commit('ADD_TO_CART', product)
    },
    newOrder({ commit }, order) {
      commit('NEW_ORDER', order)
    },
    closeCustomer({ commit }) {
      commit('CLOSE_CUSTOMER')
    },
    setCustomerActivated({ commit }, activated) {
      commit('SET_CUSTOMER_ACTIVATED', activated)
    },
    createMeasure({ commit }, measure) {
      commit('CREATE_MEASURE', measure)
    },
    editMeasure({ commit }, measure) {
      commit('EDIT_MEASURE', measure)
    },
    setCurrentShirt({ commit }, shirt) {
      commit('SET_CURRENT_SHIRT', shirt)
    },
    setCurrentMeasure({ commit }, measure) {
      commit('SET_CURRENT_MEASURE', measure)
    },
    deleteMeasure({ commit }, measures) {
      commit('DELETE_MEASURE', measures)
    },
    duplicateMeasure({ commit }, measures) {
      commit('DUPLICATE_MEASURE', measures)
    },
    createAddress({ commit }, address) {
      commit('CREATE_ADDRESS', address)
    },
    deleteAddress({ commit }, address) {
      commit('DELETE_ADDRESS', address)
    },
    setCurrentAddress({ commit }, address) {
      commit('SET_CURRENT_ADDRESS', address)
    },
    saveAddress({ commit }, address) {
      commit('SAVE_ADDRESS', address)
    },
    setCurrentCustomerMeasures({ commit }, measures) {
      commit('SET_CURRENT_CUSTOMER_MEASURES', measures)
    },
    setCurrentCustomerOrders({ commit }, orders) {
      commit('SET_CURRENT_CUSTOMER_ORDERS', orders)
    },
    setCurrentCustomerAddresses({ commit }, addresses) {
      commit('SET_CURRENT_CUSTOMER_ADDRESSES', addresses)
    },
    addFromExistingProduct({ dispatch, state }, product) {
      if (!state.current_customer_id) {
        return
      }
      dispatch('addFromSearchOrOrderToCart', product)
    },
    addProductFromOrder({ dispatch, state }, product) {
      if (!state.current_customer_id) {
        return
      }
      dispatch('addFromSearchOrOrderToCart', product)
    },
    addFromSearchOrOrderToCart({ commit, state, rootGetters }, originalProduct) {
      if (!state.current_customer_id) {
        return
      }

      const groups = rootGetters.getGroups;

      // Initialize product
      const product = {
        id: uniqid(),
        id_product: originalProduct.id_product,
        reference: originalProduct.reference,
        customizable: originalProduct.customizable || false,
        isShirt: originalProduct.isShirt,

        // Combinations
        combinations: originalProduct.combinations,
        id_combination: originalProduct.id_combination || null,

        // FIXME: Solve this inconsistency
        id_product_attribute: originalProduct.id_product_attribute || null,
        product_attribute_id: originalProduct.product_attribute_id || null,

        id_order: originalProduct.id_order || null,
        attribute_list: originalProduct.attribute_list || {},
        name: originalProduct.name || (!+originalProduct.customizable && originalProduct.product_name) || 'Shirt',
        created: true,
        options: originalProduct.options || {},
        measure_id: originalProduct.measure_id || null,
        cart_quantity: 1,

        // FIXME: Solve this inconsistency
        original_product_price: originalProduct.original_product_price,
        presta_price: originalProduct.presta_price,
        fms_suggested_price: originalProduct.fms_suggested_price,
        price: parseFloat(originalProduct.price || (originalProduct.id_combination && originalProduct.combinations[originalProduct.id_combination].price_tax_incl) || 0),
        source: originalProduct.source || '',
        // FIXME: Solve this inconsistency
        fms_factory_reference: originalProduct.fms_factory_reference,
        formens_ref: originalProduct.formens_ref,
        fms_product_type: originalProduct.fms_product_type,
        product_type: originalProduct.product_type,
        fms_pattern_base: originalProduct.fms_pattern_base,
        fms_base_size: originalProduct.fms_base_size
      }

      // Copy original product to the new product
      // product = Object.assign(product, originalProduct)

      if(+product.customizable === 0 || product.source === 'order') {
        commit('ADD_TO_CART', product)
        return;
      }

      // Look for custom options (measure and initiales)
      let initials = ''
      if (originalProduct.customizedDatas && originalProduct.customizedDatas[0]) {
        const customizedData = originalProduct.customizedDatas[0];
        const { datas } = Object.values(customizedData)[0]

        Object.values(datas).forEach((customizationObj) => {
          Object.values(customizationObj).forEach((customization) => {
            if (customization.name === 'Measures' || customization.name === 'Patron') {
              product.measure_id = customization.value
            }
            if (customization.name === 'Initials' || customization.name === 'Initiales') {
              initials = customization.value
            }
          })
        })
      }


      // Retrieve original product attributes
      const combination = originalProduct.combinations[originalProduct.product_attribute_id] || {}
      const originalAttributes = combination.attribute_list || {};

      // Flush the original product options
      product.options = {};

      // Set all the options on the new product.
      groups.forEach((group) => {
        product.options[group.id] = {}
        group.parameters.forEach((parameter) => {
          if (!['OPTION', 'SELECT_ONE', 'TEXT'].includes(parameter.type)) {
            // eslint-disable-next-line no-console
            console.log('Invalid parameter type', parameter.type);
            return
          }

          product.options[group.id][parameter.code] = {}

          if (parameter.code === 'TISSU') {

            // TODO: Fetch the fabric code from the original product
            const idTissu = parseInt(originalProduct.id_tissu, 10) + 1000000

            parameter.values.forEach((value) => {
              if (value.code === idTissu) {
                product.options[group.id][parameter.code] = value
              }
            })
            return
          }

          if (parameter.code === 'DOUBLURETISSU') {
            // TODO: Fetch the fabric code from the original product
            const idTissuDoublure = parseInt(originalProduct.id_tissu_doublure, 10) + 1000000
            parameter.values.forEach((value) => {
              if (value.code === idTissuDoublure) {
                product.options[group.id][parameter.code] = value
              }
            })
            return
          }

          if (parameter.code === 'TEXTINITIAL') {
            product.options[group.id][parameter.code] = initials
            return
          }

          // Copy relevant attributes from they exists from the original product.
          Object.keys(originalAttributes).forEach((attributeCode) => {

            // If the attribute doesn't exists in the new structure, we ignore it
            if (!(parameter.code.trim().toUpperCase() === attributeCode.trim().toUpperCase())) {
              return
            }

            // Copy the value of the parameter.
            parameter.values.forEach((value) => {
              // If the value doesn't exists in the new structure, we ignore it.
              if (!((value.code.trim().toUpperCase() === originalAttributes[attributeCode].trim().toUpperCase()) &&
                    parameter.type !== 'TEXT')) {
                return
              }

              // Copy the new value
              product.options[group.id][parameter.code] = value
            })
          })

          // Set default value if the parameter didn't exists.
          if (!product.options[group.id][parameter.code].code) {
            parameter.values.forEach((value) => {
              if (value.default !== '0') {
                product.options[group.id][parameter.code] = value
              }
            })
          }
        })
      })

      commit('ADD_TO_CART', product)
    }
  },
  mutations: {
    ADD_CUSTOMER(state, customer) {
      Vue.set(state.customers, customer.id, customer)
      state.current_customer_id = +customer.id
    },
    SET_CURRENT_CUSTOMER(state, customer) {
      state.current_customer_id = +customer.id
    },
    ADD_TO_CART(state, product) {
      if (!state.current_customer_id) {
        return
      }
      if (!state.customers[state.current_customer_id].cart) {
        Vue.set(state.customers[state.current_customer_id], 'cart', { products: [] })
      }
      state.customers[state.current_customer_id].cart.products.push(product)
    },
    NEW_ORDER(state, order) {
      const o = order
      o.id = state.customers[state.current_customer_id].orders.length + 1
      state.customers[state.current_customer_id].orders.unshift(o)
    },
    ADD_ORDER(state, order) {
      return order
    },
    CLOSE_CUSTOMER(state) {
      delete state.customers[state.current_customer_id]
      state.current_customer_id = null
    },
    SET_CUSTOMER_ACTIVATED(state, activated) {
      state.customers[state.current_customer_id].activated = activated
    },
    CREATE_MEASURE(state, measure) {
      state.customers[state.current_customer_id].measures.unshift(measure)
    },
    EDIT_MEASURE(state, measure) {
      state.customers[state.current_customer_id].measures.forEach((item) => {
        if (item.id === measure.id) {
          Object.keys(measure).forEach((key) => {
            // eslint-disable-next-line no-param-reassign
            item[key] = measure[key]
          })
        }
      })
    },
    SET_CURRENT_SHIRT(state, shirt) {
      state.current_shirt_id = shirt.id
      // state.customers[state.current_customer_id].cart.products[shirt_index]
    },
    SET_CURRENT_MEASURE(state, measure) {
      state.current_measure_id = measure == null ? null : measure.id
    },
    DELETE_MEASURE(state, measures) {
      state.customers[state.current_customer_id].measures = measures
    },
    DUPLICATE_MEASURE(state, measures) {
      state.customers[state.current_customer_id].measures = measures
    },
    CREATE_ADDRESS(state, address) {
      state.customers[state.current_customer_id].addresses.unshift(address)
    },
    DELETE_ADDRESS(state, address) {
      const newAddresses = state.customers[state.current_customer_id].addresses
      state.customers[state.current_customer_id].addresses =
        newAddresses.filter((addr) => addr.id !== address.id)
    },
    SET_CURRENT_ADDRESS(state, address) {
      state.current_address_id = address == null ? null : address.id
    },
    SAVE_ADDRESS(state, address) {
      state.customers[state.current_customer_id].addresses.forEach((addr) => {
        if (addr.id === address.id) {
          Object.keys(address).forEach((key) => {
            // eslint-disable-next-line no-param-reassign
            addr[key] = address[key]
          })
        }
      })
    },
    SET_CURRENT_CUSTOMER_MEASURES(state, measures) {
      const existingCustomer = state.customers[state.current_customer_id] || {};
      Vue.set(state.customers, state.current_customer_id, {
        ...existingCustomer,
        measures,
      });
    },
    SET_CURRENT_CUSTOMER_ORDERS(state, orders) {
      const existingCustomer = state.customers[state.current_customer_id] || {};
      Vue.set(state.customers, state.current_customer_id, {
        ...existingCustomer,
        orders,
      });
    },
    SET_CURRENT_CUSTOMER_ADDRESSES(state, addresses) {
      const existingCustomer = state.customers[state.current_customer_id] || {};
      Vue.set(state.customers, state.current_customer_id, {
        ...existingCustomer,
        addresses,
      });
    }
  }
}

export default Customers



// WEBPACK FOOTER //
// ./src/store/modules/customers.js